import { useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Page_settings } from '../config/page_settings'
import { rootStore } from "../mobx/store";
const GlobalEffect = () => {
  const context = useContext(Page_settings)
  const location = useLocation();

  useEffect(() => {
    context.get('member/token_check', {},
        response => {
          if (response.is_login == 0) {
            rootStore.signOut();
          }
        }
      )
  }, [location.pathname]);

  return null;
};


export default GlobalEffect;
